import { render, staticRenderFns } from "./ModalMedicineActionTakeAway.vue?vue&type=template&id=53871bc3"
import script from "./ModalMedicineActionTakeAway.vue?vue&type=script&lang=js"
export * from "./ModalMedicineActionTakeAway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports